import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// import AuthService from "../../Services/AuthService";
import { AdminAuthSliceModelProps, authUser } from "./InitialStatePropsModel";
import Storage from "./../../Helpers/Storage";
import Config from "./../../Config";

const expiryKey = `${Config.STORAGE_KEY}/accessTokenExpiry`;
const storedAccessToken =
  Storage.get(`${Config.STORAGE_KEY}/accessToken`) ?? "";
const storedRefreshToken =
  Storage.get(`${Config.STORAGE_KEY}/refreshToken`) ?? "";
const storedExpiry = Storage.get(expiryKey)
  ? Number(Storage.get(expiryKey))
  : 0;
const persistedAuth = JSON.parse(Storage.get(`${Config.STORAGE_KEY}/auth`)) ?? {
  _id: "",
  username: "",
  firstName: "",
  lastName: "",
  image: "",
  password: "",
  email: "",
  accessToken: "",
  refreshToken: "",
  empId: "",
  mobile: "",
  phoneNumber: "",
  countryDialCode: "",
  countryIsoCode: "",
  roleId: "",
};

// Debug: Check if stored expiry matches actual token expiry
if (storedAccessToken) {
  try {
    const tokenPayload = JSON.parse(atob(storedAccessToken.split(".")[1]));
    const actualExpiry = tokenPayload.exp;
    const currentTime = Math.floor(Date.now() / 1000);

    // Clear persisted auth if token is expired to force refresh
    if (currentTime > actualExpiry) {
      localStorage.removeItem("persist:auth");
    }
  } catch (e) {
    console.log("Could not decode token for debugging");
  }
}

// Use actual token expiry if available, fallback to stored expiry
let actualExpiry = storedExpiry;
if (storedAccessToken) {
  try {
    const tokenPayload = JSON.parse(atob(storedAccessToken.split(".")[1]));
    actualExpiry = tokenPayload.exp;
  } catch (e) {
    console.log("❌ Could not decode token, using stored expiry");
  }
}

const initialState: AdminAuthSliceModelProps = {
  isAuthenticated: !!(storedAccessToken && storedRefreshToken), // Set true if tokens exist
  accessToken: storedAccessToken,
  refreshToken: storedRefreshToken,
  accessTokenExpiry: actualExpiry,
  authUser: persistedAuth,
  error: "",
  isLoading: false,
};

const AuthSlice = createSlice({
  name: "AuthSlice",
  initialState,
  reducers: {
    setAuthUser(state: any, action: any) {
      state.authUser = action.payload;
      // Only update isAuthenticated if we have user ID OR if we have valid tokens
      if (action.payload?._id) {
        state.isAuthenticated = true;
      } else if (!state.accessToken || !state.refreshToken) {
        // Only set to false if we don't have tokens
        state.isAuthenticated = false;
      }
      // If we have tokens but no user ID yet, keep isAuthenticated as true
    },
    logout(state: any) {
      sessionStorage.clear();
      state.authUser = {};
      state.isAuthenticated = false;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },

    setAuthAddress(state: any, action: any) {
      state.authUser.addresses = action.payload;
    },
    setAccessToken(
      state,
      action: PayloadAction<{ accessToken: string; refreshToken: string }>,
    ) {
      // const time=3600;  // 1 hour from now
      const time = 3480; // 58 minutes = 3480 seconds;
      // const time=58; // 58 seconds from now
      const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
      state.accessTokenExpiry = currentTime + time;
      // state.accessTokenExpiry = currentTime + 3600; // 1 hour from now
      Storage.set(
        `${Config.STORAGE_KEY}/accessToken`,
        action.payload.accessToken,
      );
      Storage.set(
        `${Config.STORAGE_KEY}/refreshToken`,
        action.payload.refreshToken,
      );
      Storage.set(
        `${Config.STORAGE_KEY}/accessTokenExpiry`,
        (currentTime + time).toString(),
      );
    },
  },
});
export const { setAuthUser, logout, setAccessToken, setAuthAddress } =
  AuthSlice.actions;
export default AuthSlice;
